import {Mask} from '@tboerc/maskfy';
import React, {useEffect, useImperativeHandle, useRef} from 'react';

import Art from '../../../../assets/img/info.png';

const CALLER = 'SEGURADO_BASIC';

const Equipamentos = ({
  position,
  current,
  checkAdvance,
  prevData,
  onAdvance,
  onRemoveEquipment,
  onSetEquipmentToUpdate,
  regress,
  corPrimaria,
  onSubmitQuote,
  gerouCotacao,
}) => {
  const sizeRef = useRef();

  useImperativeHandle(ref, () => ({
    values: () => ({caller: CALLER, data: {}}),
    ref: sizeRef,
  }));

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: prevData.segurado_bicicletas?.length > 0});
  });

  const calculaSoma = (bikes) => {
    let total = 0;

    if (bikes.length > 0) {
      bikes.forEach((bike) => {
        total += bike.total_coberturas - (bike.total_coberturas * DESCONTO) / 100;
      });
    }

    return total;
  };

  const DESCONTO =
    prevData.segurado_bicicletas?.length >= 2
      ? prevData.segurado_bicicletas?.length >= 2 && prevData.segurado_bicicletas?.length <= 3
        ? 15
        : 25
      : 0;

  const SOMATORIA = calculaSoma(prevData.segurado_bicicletas);

  return (
    <form className="formStep" ref={sizeRef}>
      <div className="controlForms">
        <div className="leftSide">
          <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Equipamentos cadastrados</h1>
          {prevData.modal !== 2 && prevData.modal !== 3 && prevData.modal !== 4 && prevData.modal !== 1 && (
            <p>Selecione até cinco equipamentos para contratação de um novo seguro.</p>
          )}
        </div>

        <div className="rightSide">
          <div className="equipaments">
            <div
              className="header d-flex justify-content-between align-items-center"
              style={{background: !!corPrimaria ? corPrimaria : '#023a86', borderColor: !!corPrimaria ? corPrimaria : '#023a86'}}>
              {prevData.modal !== 2 && prevData.modal !== 3 && prevData.modal !== 4 && prevData.modal !== 1 && (
                <p>
                  Equipamentos cadastrados{' '}
                  {prevData.segurado_bicicletas?.length >= 2 ? (
                    prevData.segurado_bicicletas?.length >= 2 && prevData.segurado_bicicletas?.length <= 3 ? (
                      <small>(15% de desconto aplicado)</small>
                    ) : (
                      <small>(25% de desconto aplicado)</small>
                    )
                  ) : (
                    <></>
                  )}
                </p>
              )}
              <div>
                <p>
                  Somatória:{' '}
                  {Mask.money.value(
                    parseFloat(
                      prevData.cupom
                        ? prevData.cupom.tipo_desconto === 0
                          ? SOMATORIA - (SOMATORIA * prevData.cupom.valor_desconto) / 100
                          : SOMATORIA - prevData.cupom.valor_desconto
                        : SOMATORIA,
                    ).toFixed(2),
                  )}
                </p>
                {prevData.cupom && (
                  <small className="text-white">
                    Cupom aplicado: {prevData.cupom.codigo} -{' '}
                    {prevData.cupom.tipo_desconto === 0
                      ? prevData.cupom.valor_desconto + '%'
                      : Mask.money.value(prevData.cupom.valor_desconto)}
                  </small>
                )}
              </div>
            </div>
            <div className="body" style={{fontSize: '.8rem'}}>
              {prevData.segurado_bicicletas?.length > 0 ? (
                <>
                  {prevData.segurado_bicicletas.map((bike, index) => (
                    <>
                      <div className="d-flex align-items-center justify-content-between" key={index}>
                        <p style={{width: '10%'}}>
                          <b>Item {index + 1}</b>
                        </p>
                        <p style={{width: '30%'}}>
                          <b>{bike.modelo}</b>
                        </p>
                        <p style={{width: '35%'}}>
                          {bike.coberturas.coberturas.length} cobertura(s) (
                          {Mask.money.value(
                            parseFloat(bike.total_coberturas - (bike.total_coberturas * DESCONTO) / 100).toFixed(2),
                          )}
                          )
                        </p>
                        <div className="d-flex flex-column align-items-center">
                          <button type="button" onClick={() => onRemoveEquipment(index)} className="btnRemoveEquipament">
                            <p>Remover</p>
                          </button>
                          <button
                            type="button"
                            onClick={() => onSetEquipmentToUpdate(index)}
                            className="btnUpdateEquipament"
                            style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                            <p>Editar</p>
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </>
              ) : (
                <>
                  <p>
                    <b>Nenhum equipamento cadastrado</b>
                  </p>
                  <p>
                    {prevData.modal === 1
                      ? 'Adicione equipamentos abaixo, você pode cadastrar até 1 equipamento'
                      : prevData.modal !== 2 && 'Adicione equipamentos abaixo, você pode cadastrar até 5 equipamentos'}
                  </p>
                </>
              )}
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <button
              disabled={
                gerouCotacao ||
                prevData.segurado_bicicletas?.length === 5 ||
                ((prevData.modal === 1 || prevData.modal === 2 || prevData.modal === 3) &&
                  prevData.segurado_bicicletas?.length === 1)
              }
              type="button"
              tabIndex={-1}
              onClick={() => {
                onAdvance();
                function gtag_report_conversion(url) {
                  var callback = function () {
                    if (typeof url != 'undefined') {
                      window.location = url;
                    }
                  };
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-10999123839/pP7ZCJfwteUDEP-e5fwo',
                    event_callback: callback,
                  });
                  return false;
                }
                gtag_report_conversion();
              }}
              className={`btnAddEquipament ${
                (gerouCotacao ||
                  prevData.segurado_bicicletas?.length === 5 ||
                  ((prevData.modal === 1 || prevData.modal === 2 || prevData.modal === 3) &&
                    prevData.segurado_bicicletas?.length === 1)) &&
                'cantAdvance'
              }`}
              style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
              <span>+ Adicionar um novo equipamento</span>
            </button>
            <button
              disabled={prevData.segurado_bicicletas?.length < 1}
              type="button"
              tabIndex={-1}
              onClick={() => {
                onSubmitQuote({tipo: 'cotacao'});
              }}
              className={`btnAddEquipament ${prevData.segurado_bicicletas?.length < 1 && 'cantAdvance'}`}
              style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
              <span>Gerar PDF da cotação</span>
            </button>
          </div>
          <div className="wrapperBikeDiscount">
            {prevData.modal !== 3 && (
              <>
                <img src={Art} width={32} height={32} />
                {prevData.modal !== 2 && (
                  <p>
                    Receba 15% de desconto ao inserir entre 2 a 3 equipamentos. <br />
                    Receba 25% de desconto ao inserir entre 4 a 5 equipamentos.
                    {prevData.modal === 1 && (
                      <>
                        <br /> <br />
                        ** Para modais elétricos é permitido apenas 1 equipamento na contratação.
                      </>
                    )}
                  </p>
                )}
              </>
            )}
            {prevData.modal === 2 && (
              <p style={{textAlign: 'justify'}}>
                O Bici Sura Essencial é destinado para bicicletas com Notas Fiscais emitidas a no máximo 36 meses (3 anos) da data
                de contratação do seguro, com valor de novo de até R$ 5.000,00 e não prevê a contratação de várias bicicletas na
                mesma apólice.
              </p>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default React.memo(Equipamentos);
export const ref = React.createRef();
